import { vidaClassicTheme } from '@vidahealth/vida-ui/themes';

// This local extension layer exists so we can override or add style rules on
// top of vidaClassicTheme without forking it. vida-ui's classic theme keeps
// evolving — anything app-specific (e.g. button sizing tweaks below) lives
// here and survives upstream upgrades.
export const onboardingTheme = vidaClassicTheme.extend({
  key: 'onboarding',
  name: 'Onboarding',
  tokens: {
    // Override any app-specific tokens here.
  },
});
